const getDashboardUrl = (path, monthYear) => {
  const base = "dashboard"; // backend path prefix
  return `${base}/${monthYear}${path ? `/${path}` : ""}`;
};

export default getDashboardUrl;
